import { Stack, Tab, Tabs, Typography, styled } from '@mui/material';
import Grid from '@mui/material/Grid2';

interface NoteHeaderTitleProps {
  isOwner: boolean;
}

export const HeaderGridContainer = styled(Grid)`
  width: 100%;
  /* Allow header to grow vertically when title wraps */
  min-height: 64px;
  height: auto;
  justify-content: space-between;
  /* ensure space below header so it doesn't overlap content */
  margin-bottom: 16px;
  max-width: 1620px;
`;

export const TextGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 1000px;
`;

export const ButtonsGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  max-width: 650px;
`;

export const StyledTabs = styled(Tabs)`
  background: rgba(118, 118, 128, 0.12);
  border-radius: 20px;
  height: 45px;
  min-height: 45px;
  margin-bottom: 1.5rem;
  position: relative;
  overflow: hidden;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .MuiTabs-indicator {
    box-shadow:
      0px 3px 1px 0px rgba(0, 0, 0, 0.04),
      0px 3px 8px 0px rgba(0, 0, 0, 0.12);
    background: ${({ theme }) => theme.palette.background.paper};
    height: 41px;
    border-radius: 20px;
    bottom: 2px;
    z-index: 1;
  }

  .MuiTabs-scroller {
    height: 100%;
    padding: 2px 2px 0px;
    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
      max-width: 100%;
    }
  }

  .MuiTabs-flexContainer {
    height: 100%;
    position: relative;
    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
      justify-content: space-between;
    }
  }
`;

export const StyledTab = styled(Tab)`
  text-transform: none;
  font-size: 13px;
  letter-spacing: -0.08px;
  color: ${({ theme }) => theme.palette.text.primary};
  height: 41px;
  min-height: 41px;
  position: relative;
  z-index: 2;
  flex: 1;
  max-width: none;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    font-size: 12px;
  }

  &.Mui-selected {
    font-weight: 600;
    color: ${({ theme }) => theme.palette.text.primary};
    transition: font-weight 0.5s;
    border-radius: 20px;
  }
`;

export const WhiteWrapper = styled(Stack)`
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 13px;
  padding: 1rem;
  width: 100%;
`;

export const ClickableWhiteWrapper = styled(WhiteWrapper, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>`
  cursor: pointer;
  margin-bottom: 8px;
  flex-direction: row;
  gap: 16px;
  border: ${({ selected, theme }) => (selected ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent')};
  background: ${({ selected, theme }) => (selected ? '#e3f2fd' : theme.palette.common.white)};
  box-sizing: border-box;
`;

export const NoteHeaderTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isOwner',
})<NoteHeaderTitleProps>`
  font-size: 1.5rem;
  font-weight: 700;
  cursor: ${({ isOwner }) => (isOwner ? 'pointer' : 'default')};
  /* Add spacing below title before date */
  margin-bottom: ${({ theme }) => theme.spacing(1)};

  &:hover {
    color: ${({ theme, isOwner }) => (isOwner ? theme.palette.primary.main : 'inherit')};
  }
`;
